export default "__VITE_ASSET__Crsk3pOC__"